import { FC, useMemo } from 'react'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import { ImageTransformer } from 'src/relay/Transformers/ImageTransformer'
import IllustrationCarousel, {
  IllustrationCarouselProps,
} from 'src/components/IllustrationCarousel'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'

import { BlockProps } from '../props'
import { colors } from '../../../theme'
import { ActionIconBackground } from '../../../components/ActionButton/types'

import { SliderImageBlockProps } from './props'

const SliderImageBlock: FC<BlockProps<SliderImageBlockProps>> = ({
  data,
  configuration,
  locale,
}) => {
  const props: IllustrationCarouselProps = useMemo(() => {
    const captions = data.imagesCaptions
      ? data.imagesCaptions.split('\n').filter((caption) => !!caption)
      : []
    return {
      ...(data.title && {
        blockTitleProps: {
          title: data.title,
          ...(data.sectionTitle && {
            tag: data.sectionTitle,
          }),
          color: getThemeColor(data.theme?.data),
        },
      }),
      illustrations:
        // v4 wraps media as `images.data[]`; v5 returns a flat array.
        ((data?.images as any)?.data ?? data?.images ?? []).map(
          (imageRaw: any, index: number) => {
            const attrs: any = imageRaw?.attributes ?? imageRaw
            const imageProps = ImageTransformer(imageRaw, {
              tablet: '100vw, 75vw',
            })
            return {
              caption: captions?.[index] || attrs?.caption || '',
              ...(imageProps && { pictureProps: { imageProps } }),
            }
          }
        ),
      ...(data.cta && {
        actionButtonProps: ButtonTransformer({
          data: data.cta,
          theme: data.theme?.data,
          forceColor: colors.blueLight,
          iconBackground: ActionIconBackground.color,
        }),
      }),
      ...(data.description && {
        richTextProps: RichTextTransformer(
          data.description,
          configuration,
          locale
        ),
      }),
    }
  }, [
    configuration,
    data.cta,
    data.description,
    data?.images,
    data.imagesCaptions,
    data.sectionTitle,
    data.theme?.data,
    data.title,
    locale,
  ])

  return <IllustrationCarousel {...props} />
}

export default SliderImageBlock
